import {
  getListingOptionsQuery, saveListingOptionMutation, setListingOptionActiveMutation,
  deleteListingOptionMutation, adminSetListingOptionDisabledMutation,
  getBookingOptionSettingsQuery, updateBookingOptionSettingsMutation
} from '../../lib/graphql/listingOptions';

// Every action resolves to { status, errorMessage, results, maxCustom, customCount } (WEB status convention).
const failure = { status: 'failed', errorMessage: null, results: null };

const runQuery = (variables) => async (dispatch, getState, { client }) => {
  try {
    const { data } = await client.query({ query: getListingOptionsQuery, variables, fetchPolicy: 'network-only' });
    return data?.getListingOptions || failure;
  } catch (error) {
    return failure;
  }
};

const runMutation = (mutation, name, variables) => async (dispatch, getState, { client }) => {
  try {
    const { data } = await client.mutate({ mutation, variables });
    return data?.[name] || failure;
  } catch (error) {
    return failure;
  }
};

export const fetchListingOptions = (listId) => runQuery({ listId: Number(listId) });

export const saveListingOption = (variables) => runMutation(
  saveListingOptionMutation, 'saveListingOption', { ...variables, listId: Number(variables.listId) }
);

export const setListingOptionActive = ({ listId, slot, isActive }) => runMutation(
  setListingOptionActiveMutation, 'setListingOptionActive', { listId: Number(listId), slot, isActive }
);

export const deleteListingOption = ({ listId, slot }) => runMutation(
  deleteListingOptionMutation, 'deleteListingOption', { listId: Number(listId), slot }
);

export const adminSetListingOptionDisabled = ({ listId, slot, disabled, reason }) => runMutation(
  adminSetListingOptionDisabledMutation, 'adminSetListingOptionDisabled',
  { listId: Number(listId), slot, disabled, reason }
);

// Admin: platform settings of the booking options (custom options limit, fixed services switches).
export const fetchBookingOptionSettings = () => async (dispatch, getState, { client }) => {
  try {
    const { data } = await client.query({ query: getBookingOptionSettingsQuery, fetchPolicy: 'network-only' });
    return data?.getBookingOptionSettings || failure;
  } catch (error) {
    return failure;
  }
};

export const saveBookingOptionSettings = ({ maxCustomOptions, deliveryEnabled, chauffeurEnabled }) => runMutation(
  updateBookingOptionSettingsMutation, 'updateBookingOptionSettings',
  { maxCustomOptions: Number(maxCustomOptions), deliveryEnabled: Boolean(deliveryEnabled), chauffeurEnabled: Boolean(chauffeurEnabled) }
);
